<svg
    viewBox="0 0 29 21"
    version="1.1"
    id="svg5"
    sodipodi:docname="Primary_Icons_Master_Light_Blue_client.svg"
    width="20"
    height="21"
    inkscape:version="1.3.2 (091e20e, 2023-11-25, custom)"
    xmlns:x="adobe:ns:meta/"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:svg="http://www.w3.org/2000/svg"
    xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
>
    <defs id="defs1">
        <style id="style1">
            .a {
                fill: #2a498c; // #106fb7;
            }

            .b {
                fill: #8ba0cf;
            }
        </style>
    </defs>
    <path
        class="a"
        d="M 10.018201,10.976404 A 4.95,4.95 0 1 0 5.0682012,5.9764024 4.94,4.94 0 0 0 10.018201,10.976404 Z m 2.480001,2.48 H 7.4982012 a 7.43,7.43 0 0 0 -7.43,7.43 H 19.928202 a 7.43,7.43 0 0 0 -7.43,-7.43 z"
        id="path1"
    />
    <path
        class="b"
        d="m 20.558202,8.4564024 a 4.16,4.16 0 1 0 -4.16,-4.15 4.15,4.15 0 0 0 4.16,4.15 z"
        id="path4"
    />
    <path
        class="b"
        d="m 20.018202,16.776404 h 8.89 a 6.24,6.24 0 0 0 -6.28,-6.26 h -4.15 a 6.24,6.24 0 0 0 -4.52,2 8.57,8.57 0 0 1 6.06,4.26 z"
        id="path5"
    />
</svg>
